import PaymentModalContainer from "./paymentModalContainer";

export default {
  PaymentModalContainer
};
